<template>
  <div>
    <div class="bg">
      <div class="container">
        <v-card class="newcard ">
          <v-row>
            <v-col>
              <img
                src="@/assets/imgs/seedadminlogo.png"
                alt="Vue Material Admin"
                width="450px"
                height="650px"
                style="padding-left: 6%;margin-top:9%"
              />
            </v-col>

            <v-col>
              <div style="padding-left:4%; padding-top:10px">
                <v-img
                  align-center
                  justify-center
                  alt="Seed Logo"
                  class="app img mx-auto mt-15"
                  src="@/assets/imgs/thumbnail_LOGO - Seed 2.png"
                  transition="scale-transition"
                  width="170px"
                  height="162px"
                />

                <v-alert
                  type="error"
                  class="text"
                  style="font-size: 22px"
                  v-model="erroralert"
                  >{{ errorMessage }}</v-alert
                >
                <v-alert
                  type="info"
                  class="text"
                  style="font-size: 22px"
                  color="#61803A"
                  v-model="successalert"
                  >{{ successMessage }}</v-alert
                >
                <v-form class="form mb-5 ml-3 mr-3 text-center">
                  <v-row class="justify-center">
                    <label align="center" class="title-text labelbold"
                      >Enter your email to reset your password</label
                    >
                  </v-row>
                </v-form>
                <label class="mt-5 ml-15 labelbold " style="padding-left: 35px">
                  Email
                </label>
                <v-row class="justify-center">
                  <v-text-field
                    background-color="#efefef"
                    class="mt-2 text textboxpassword justify-center"
                    height="38px"
                    type="text"
                    name="login"
                    autocomplete="off"
                    v-model="email"
                    outlined
                    :rounded="true"
                  ></v-text-field>
                </v-row>

                <v-row>
                  <v-spacer />
                  <router-link
                    to="/"
                    class=" text labelbold mr-15 mt-5 "
                    style="font-size:10px; padding-right:50px"
                    >Back to Login</router-link
                  >
                </v-row>

                <v-layout flex align-center justify-center>
                  <v-btn
                    class="login mt-13"
                    large
                    color="#A6CC39"
                    align="center"
                    justify="center"
                    style="color:#fff!important"
                    @click="ResetPassword"
                    height="46px"
                    :loading="loading"
                    :rounded="true"
                    >Reset Password</v-btn
                  >
                </v-layout>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>

    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#6CC8A0" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#fff"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import GlobalMixin from "./Mixins/GlobalMixin";
import enurl from "@/api/environment";
import axios from "axios";
export default {
  name: "resetPassword",
  mixins: [GlobalMixin],
  data() {
    return {
      email: "",
      uID: "",
      images: {
        logo: require("@/assets/imgs/SeedIcon.png"),
        BG: require("@/assets/imgs/seedadminlogo.png")
      },
      url: enurl.apiUrl,
      errorMessage: "Mail Not Found",
      successMessage: "Please check your Email for password",
      dialog: false,
      loading: false,
      erroralert: false,
      successalert: false
    };
  },

  methods: {
    ResetPassword() {
      let self = this;

      self.dialog = true;
      self.successalert = false;
      self.erroralert = false;

      let eMail = self.email;
      axios
        .post(
          `${self.url}/Login/ForgetpasswordByProduct?eMail=${eMail}&type=COM`
        )
        .then(function(response) {
          let check = response.data.data;
          if (check) {
            self.successalert = true;
            setTimeout(function() {
              self.$router.push("/");
            }, 3000);
          } else {
            self.erroralert = true;
          }
          self.dialog = false;
        })
        .catch(function(error) {});
    }
  }
};
</script>

<style scoped>
* >>> .textboxpassword .v-input__control > .v-input__slot {
  min-height: 38px !important;
}
.v-input {
  max-width: 60%;
  max-height: 10%;
}
.bg {
  background: url("~@/assets/imgs/Component 87 – 98.png") no-repeat center
    center;
  background-size: cover;
  object-fit: contain;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #ffffff;
  transform: scale(1);
}
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Set height to viewport height for vertical centering */
}
.newcard {
  width: 100%;
  height: 800px;
}
::v-deep .theme--light .v-label {
  color: #47484b !important;
  font-weight: bold;
}
.login {
  width: 14rem;
  margin-top: 8rem;
}
.img-intersection {
  width: 100%;
  height: 65vh;
  max-width: 100%;
}
.forgetPass {
  font-size: 18px;
  margin-top: -2rem;
}
.form {
  min-width: 50%;
  margin-top: 7rem;
}
.labelbold {
  font-weight: bold;
  color: #5a5a5a;
}
</style>
